module.exports = __webpack_public_path__ + "static/assets/76aab724a3dee349e125c5293ff55c0f.png";